import React, { useEffect, useState } from "react";
import { Form, Button, Container, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Cookies from 'js-cookie'
import toast from "react-hot-toast";
import { TbLock } from "react-icons/tb";
import { postAdminAuth } from "./API/Login/Login";

export const AdminLogin = () => {
    const navigate = useNavigate();
    const [form, setForm] = useState({
        ownerName: '',
        password: ''
    })

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const auth: any = await postAdminAuth(form);
        if (auth?.status === 200 && auth?.data?.token) {
            Cookies.set('loggedAs', 'admin')
            Cookies.set('Token', auth.data.token)
            navigate('/admin/dashboard')
        } else {
            toast.error('Usuario o contraseña incorrectos')
        }
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    }

    useEffect(() => {
        const loggedAs = Cookies.get('loggedAs');
        const token = Cookies.get('Token');
        if (token && loggedAs === 'user') {
            navigate('/dashboard')
        }
        if (token && loggedAs === 'admin') {
            navigate('/admin/dashboard')
        }
    }, [navigate])

    return (
        <Container
            className="d-flex justify-content-center align-items-center vh-100"
        >
            <div className="d-flex flex-column gap-3">
                <div>
                    <Card className="text-center" style={{ width: "450px", padding: "20px", borderRadius: "12px" }}>
                        <div className="d-flex align-items-center justify-content-between text-primary">
                            Panel de Administrador
                            <div>
                                <TbLock size={30} />
                            </div>
                        </div>
                    </Card>
                </div>

                <Card style={{ width: "450px", padding: "20px", borderRadius: "12px" }}>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3">
                            <Form.Label className="text-xs">Nombre Administrador</Form.Label>
                            <Form.Control type="text" placeholder="Escribir administrador" name="ownerName" value={form.ownerName} onChange={handleChange} />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label className="text-xs">Contraseña</Form.Label>
                            <Form.Control type="password" placeholder="Escribir contraseña" name="password" value={form.password} onChange={handleChange} />
                        </Form.Group>

                        <Button
                            variant="primary"
                            type="submit"
                            className="w-100"
                            style={{ border: "none" }}
                            disabled={!form.ownerName || !form.password}
                        >
                            Iniciar sesión
                        </Button>
                    </Form>
                </Card>
            </div>
        </Container>
    );
};
